import React, { Component } from "react";
import { Segment, Header, Image } from "semantic-ui-react";

export default class Home extends Component {
  render() {
    return (
      <Segment basic textAlign="center" className="no-pad">
        <Segment className="pictureHolder" basic textAlign="center">
          <Segment className="picture rotateLeft clickable" basic onClick={() => this.props.history.push("/times")}>
            <Image src={require("../assets/maggie.jpeg")} centered bordered size="medium" />
            <Header>Click here for your times</Header>
          </Segment>
          <Segment className="picture rotateRight clickable " basic>
            <a
              href={
                "https://nsarda.enthuse.com/cf/Help-NSARDA-Kent-Association"
              }
              rel="noopener noreferrer"
              target={"_blank"}
            >
              <Image
                src={require("../assets/sid1.jpeg")}
                centered
                bordered
                size="medium"
              />

              <Header>Please Donate Here</Header>
            </a>
          </Segment>
        </Segment>
      </Segment>
    );
  }
}
